import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import FormHelperText from '@mui/material/FormHelperText';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
  Grid,
  Typography,
  Divider,
  Box,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  Tooltip,
  FormControlLabel,
  Radio,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Icon from "../../../components/icon";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CustomLabel from "components/CustomLabel";

import { DataGrid } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomTextField from 'components/mui/text-field';
import CustomAutocomplete from 'components/mui/autocomplete';
import AddSalesTaxDialog from './AddSalesTaxDialog';
import { stateNames , expandStateName} from '../../../components/US_StatesNames';

import {
  SaveCompanySettings,
  GetCompanySettings,
  SaveSalesTax,
  GetSalesTaxes,
  DeleteSalesTax,
} from '../logic/CompanySettingsLogic';
import { SaveAttachments } from 'components/logic/SaveAttachments';
import { GetAttachments } from 'components/logic/GetAttachments';
import { DeleteAttachment } from 'components/logic/DeleteAttachment';
import { useNavigate } from 'react-router-dom';
import { DownloadAttachments } from 'components/logic/DownloadAttachments';
import { useSettingPermission } from '../permissions/SettingPermissions';


// import TabPanel from 'components/TabPanel';

const CompanySettingsTab = ({
  columnsSalesTaxRate,
  openSalesTaxDlg,
  handleOpenSalesTaxDlg,
  handleCloseSalesTaxDlg,
}) => {
    //#region Permissions
    const { SettingPermissionProps } = useSettingPermission();
    const {
      // CompanySettings Permissions
      hasCompanySavePermission,
      hasCompanyGetPermission,
  
      // Sales Tax Permissions
      hasSalesTaxSavePermission,
      hasSalesTaxGetPermission,
      hasSalesTaxDeletePermission,
    } = SettingPermissionProps;
    //#endregion Permissions

  const theme = useTheme();
  const MySwal = withReactContent(Swal);
  const [errors, setErrors] = useState({});
  const [settings, setSettings] = useState({
    companyID: 0,
    companyName: '',
    companyPhone: '',
    street1: '',
    street2: '',
    city: '',
    state: null,
    zipCode: '',
    county: '',
    chargeSalesTaxOn: 'material',
    isActive: true,
    timezoneOption: null,
  });
  const [salesTaxes, setSalesTaxes] = useState([]);
  const [logoFile, setLogoFile] = useState(null);        // The File you want to upload
  const [logoPreview, setLogoPreview] = useState(null);  // Image URL for preview
  const [logoMeta, setLogoMeta] = useState(null);        // API metadata (id, name)
  const [logoLoading, setLogoLoading] = useState(false);
  const [editingTax, setEditingTax] = useState(null);    // Track which tax is being edited

  const navigate = useNavigate();
  // Prefill form and grid on mount

  // useEffect(() => {
  //   const fetchLogo = async () => {
  //     setLogoLoading(true);
  //     // API: GetAttachments("Other", "Company", 0, 0)
  //     const logo = await GetAttachments("Other", "Company", 0, 0, navigate);
  //     console.log(logo)
  //     if (logo && logo.length > 0) {
  //       // Assuming logo[0] if multiple, or use logo as object
  //       const l = logo[0] || logo;
  //       setLogoMeta(l);
  //       setLogoPreview(l.mediaUrl); // or whatever field is correct (sometimes 'fileUrl')
  //     } else {
  //       setLogoMeta(null);
  //       setLogoPreview(null);
  //     }
  //     setLogoLoading(false);
  //   };
  //   fetchLogo();
  // }, []);

  useEffect(() => {
    let objectUrl;
  
    const fetchAndPreviewLogo = async () => {
      if(!hasCompanyGetPermission) return;

      setLogoLoading(true);
  
      // 1) fetch attachment metadata
      const attachments = await GetAttachments("Logo", "Company", 0, 0, navigate);
      console.log(attachments)
      if (!attachments?.length) {
        setLogoMeta(null);
        setLogoPreview(null);
        setLogoLoading(false);
        return;
      }
  
      const item = attachments[0];
      setLogoMeta(item);
  
      // 2) download the actual file as blob
      const blobOrError = await DownloadAttachments(
        "Logo",     // "Other"
        "Company",    // "Company"
        item.entityID,      // 0
        item.fileName,      // e.g. "47_dummy_1.png"
        navigate
      );
  
      if (blobOrError instanceof Blob) {
        // 3) create an object URL
        objectUrl = URL.createObjectURL(blobOrError);
        setLogoPreview(objectUrl);
      } else {
        // handle error case (blobOrError.form maybe)
        console.error(blobOrError);
        setLogoPreview(null);
      }
  
      setLogoLoading(false);
    };
    if(hasCompanyGetPermission){
      fetchAndPreviewLogo();
    }
  }, [hasCompanyGetPermission]);

  useEffect(() => {
    const load = async () => {
      // Company settings
      if(hasCompanyGetPermission){
        const cfg = await GetCompanySettings();
        
        if (cfg?.result) {
          const existing = cfg.result;
          
          setSettings({
            companyID: existing.companyID || 0,
            companyName: existing.companyName || '',
            companyPhone: existing.companyPhone || '',
            street1: existing.street1 || '',
            street2: existing.street2 || '',
            city: existing.city || '',
            state: existing.state || null,
            zipCode: existing.zipCode || '',
            county: existing.county || '',
            chargeSalesTaxOn: existing.chargeSalesTaxOn || 'material',
            isActive: existing.isActive,
            companyEmail: existing.companyEmail
          });
        }
      }

      // Sales taxes
      if(hasSalesTaxGetPermission){
        const taxes = await GetSalesTaxes(0);
        if (taxes?.result) setSalesTaxes(taxes.result);
      }
    };
    
    load();
  }, [hasCompanyGetPermission, hasSalesTaxGetPermission]);

  const isNumberOnly = (input) => {
    const numberRegex = /^\d*$/;
    return numberRegex.test(input);
  };

  const handleChange = (field) => (event) => {
    if(!hasCompanySavePermission) return;

    let value = event.target.value;
    if (field === 'zipCode') {
      // allow only digits
      value = value.replace(/\D/g, '').slice(0, 5);
    }
    setSettings((prev) => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: undefined }));
  };

  
  const handleLogoChange = (e) => {
    if(!hasCompanySavePermission) return;

    const file = e.target.files[0];
    if (!file) return;
    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  const handleLogoDelete = async () => {
    if (!logoMeta || !hasCompanySavePermission) return;

    setLogoLoading(true);
    const a = await DeleteAttachment("Logo", "Company", 0, logoMeta.mediaID, navigate);
    console.log(a)
    setLogoMeta(null);
    setLogoPreview(null);
    setLogoFile(null);
    setLogoLoading(false);
  };

  const handleSaveProfile = async () => {
    if(!hasCompanySavePermission) return;

    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Company Name validation
    if (!settings.companyName) {
      newErrors.companyName = 'Company Name is required.';
    } else if (settings.companyName.trim().length < 2) {
      newErrors.companyName = 'Company Name should be at least 2 characters.';
    }
    // Address (street1)
    // if (!settings.street1) {
    //   newErrors.street1 = 'Address is required.';
    // } else if (settings.street1.trim().length < 2) {
    //   newErrors.street1 = 'Address should be at least 2 characters.';
    // }

    // Zip Code
    // if (!settings.zipCode) {
    //   newErrors.zipCode = 'Zip Code is required.';
    // } else 
    if (settings.zipCode && !/^[0-9]+$/.test(settings.zipCode)) {
      newErrors.zipCode = 'Zip Code must be numeric.'
    }
    else if (settings.zipCode && settings.zipCode.trim().length < 2) {
      newErrors.zipCode = 'Zip Code should be at least 2 digits.';
    } else if (settings.zipCode && !isNumberOnly(settings.zipCode)) {
      newErrors.zipCode = 'This is an invalid Zip Code.';
    }
    // State
    // if (!settings.state) {
    //   newErrors.state = 'State is required.';
    // }

    if (!settings.companyEmail) newErrors.companyEmail = 'Email is required.';
    else if (!emailRegex.test(settings.companyEmail)) newErrors.companyEmail = 'Invalid email format.';

    // Phone Number (existing)
    const phone = settings.companyPhone;
    if (!phone || phone.trim() === '') {
      newErrors.phone = 'Phone number is required';
    } else if (phone.length < 10) {
      newErrors.phone = 'Invalid phone number.';
    }else if (phone.charAt(0) === '1') {
      newErrors.phone = 'Area code cannot begin with 1.';
    } else if (phone.length !== 10) {
      newErrors.phone = 'Phone number should be 10 digits';
    }
    
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return;

    if (logoFile) {
      // if there's already a logo and the names match, do nothing
      if (!(logoMeta && logoFile.name === logoMeta.fileName)) {
        // delete old logo if one exists
        if (logoMeta) {
          const a = await DeleteAttachment(
            "Logo",      // mediaType
            "Company",    // entityType
            0,            // entityId (always 0 for your delete API)
            logoMeta.mediaID,
            navigate
          );
          console.log(a)
        }
  
        // upload the new logo
        const formData = new FormData();
        formData.append("entityType", "Company");
        formData.append("mediaID", 0);
        formData.append("mediaType", "Logo");
        formData.append("file", logoFile);
        formData.append("entityID", 0);  // still 0 here per your API
        const res = await SaveAttachments(formData, navigate);
  console.log(res)
        if (res?.result) {
          setLogoMeta(res.result);
          // re-download blob for preview
          const blob = await DownloadAttachments(
            "Logo",
            "Company",
            0,
            res.result.fileName,
            navigate
          );
          if (blob instanceof Blob) {
            setLogoPreview(URL.createObjectURL(blob));
          }
          setLogoFile(null);
        }
      }
      // else: same filename → skip delete + upload
    }

    await SaveCompanySettings(settings);
  };

  const refreshTaxes = async () => {
    if(!hasSalesTaxGetPermission) return;

    const taxes = await GetSalesTaxes(0);
    if (taxes?.result) setSalesTaxes(taxes.result);
  };

 const handleAddOrUpdateTax = async (tax) => {
  if (!hasSalesTaxSavePermission) return;

  const isEdit = !!editingTax;   // true if editing, false if adding

  await SaveSalesTax(tax, isEdit);
  refreshTaxes();
  setEditingTax(null); // Reset editing state after saving
};
  const handleDeleteTax = async (id) => {
    if(!hasSalesTaxDeletePermission) return

    await DeleteSalesTax(id);
    refreshTaxes();
  };

  const handleEditTax = (tax) => {
    setEditingTax(tax);
    handleOpenSalesTaxDlg();
  };

  const confirmDeleteTax = (id) => {
    MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: "<span>You won't be able to revert this!</span>",
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
    width: '390px',
    padding: '1rem',
    focusConfirm: false,
    showCloseButton: true,
    closeButtonHtml: '&times;',
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then(result => {
      if (result.isConfirmed) {
        handleDeleteTax(id);
      
      }
    });
  };

  return (
    <>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography variant="h3">Company Settings</Typography>
            <Typography color="secondary">
              Manage your company information and preferences
            </Typography>
            <Box display="flex" alignItems="center" mt={2}>
              <InfoOutlinedIcon color="action" sx={{ ml: 0.5 }} />
              <Typography variant="body2" color="text.secondary" sx={{ ml: 1.5 }}>
                Only the owner can add, edit, and delete these details
              </Typography>
                
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>

          {/* Profile Fields */}
          <Grid item xs={12} md={6} lg={3}>
            <CustomTextField
              required
              fullWidth
              label={
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                  <Tooltip
                  title="This name will be displayed in Customer communications"
                  componentsProps={{
                  tooltip: {
                  sx: {
                  fontSize: '12px', 
                  maxWidth: 220,     
                },
                },
               }}
                >
                <InfoOutlinedIcon  sx={{ fontSize: 16, mr: 0.5 }} />
                  </Tooltip>

                  Company Name
                </Box>
              }
              value={settings.companyName}
              onChange={handleChange('companyName')}
              placeholder="Enter Company Name"
              error={!!errors.companyName}
              helperText={errors.companyName}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <FormControl fullWidth sx={{ display: 'flex', alignItems: 'center' }}
              // error={!!errors.phone}
            >
              <Box sx={{ width: '100%', maxWidth: '400px' }}>
               <CustomLabel label="Phone Number" required={true} />
                {/* <FormLabel
                  required
                  sx={{
                    mb: 0.8,
                    fontSize: '0.8rem',
                    fontWeight: 500,
                    color: theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.78) !important' : "rgba(47, 43, 61, 0.78)!important",
                    '& .MuiFormLabel-asterisk': {
                      color: theme.palette.error.main,
                    },
                  }}
                >
                  Phone Number
                </FormLabel> */}
                <Box
                  sx={{
                    '& .react-tel-input .form-control': {
                      width: '100%',
                      // match your TextField height (40px or 56px depending on density)
                      height: '40px',
                      borderRadius: '5px',
                     border: `1px solid ${errors.phone 
                      ? theme.palette.error.main 
                      : theme.palette.divider}`,
                      backgroundColor: theme.palette.background.paper,
                      paddingLeft: '58px',
                      fontSize: '1rem',
                      fontFamily: theme.typography.fontFamily,
                      color: theme.palette.text.primary,
                      '&:hover': {
                        borderColor: theme.palette.divider,
                      },
                      '&:focus': {
                        borderColor: theme.palette.primary.main,
                      },
                      outline: 'none',
                      '&::placeholder': {
                        color: theme.palette.text.disabled,
                        opacity: 1,
                      },
                    },
                    '& .react-tel-input .flag-dropdown': {
                      borderTopLeftRadius: theme.shape.borderRadius,
                      borderBottomLeftRadius: theme.shape.borderRadius,
                      borderRight: `1px solid ${theme.palette.divider}`,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                >
                  <PhoneInput
                    country={'us'}
                    onlyCountries={['us']}
                    disableDropdown={true}
                    disableCountryCode={true}
                    placeholder="(702) 123-4567"
                    value={settings.companyPhone || ''}
                    onChange={(phone) => {
                      setSettings(p => ({ ...p, companyPhone: phone }));
                      setErrors(e => ({ ...e, phone: undefined }));
                    }}
                    inputClass="form-control"
                    containerStyle={{ width: '100%' }}
                  />
                </Box>

                {errors.phone && (
                  <FormHelperText
                    sx={{
                      mt: 1,
                      ml: 0,
                      fontSize: theme.typography.body2.fontSize,    
                      lineHeight: theme.typography.caption.lineHeight,
                      color: theme.palette.error.main
                    }}
                  >
                    {errors.phone}
                  </FormHelperText>
                )}
              </Box>
            </FormControl>
          </Grid>
           <Grid item xs={12} md={6} lg={3}>
            <CustomTextField
              required
              fullWidth
              label="Email"
              value={settings.companyEmail}
              onChange={handleChange('companyEmail')}
              placeholder="info@company.com"
              error={!!errors.companyEmail}
              helperText={errors.companyEmail}
            />
          </Grid>

         <Grid item xs={12} md={6} lg={3}>
            <CustomTextField
              fullWidth
              label="Street 1"
              value={settings.street1}
              onChange={handleChange('street1')}
              placeholder="123 Main St, City, County"
              error={!!errors.street1}
              helperText={errors.street1}
            />
          </Grid>
          
          <Grid item xs={12} md={6} lg={3} >
            <CustomTextField
              fullWidth
              label="Street 2"
              value={settings.street2}
              onChange={handleChange('street2')}
              placeholder="Apt, Suite, Unit, Building, Floor, etc."
              error={!!errors.street2}
              helperText={errors.street2}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <CustomTextField
              fullWidth
              label="City"
              value={settings.city}
              onChange={handleChange('city')}
              placeholder="Enter City"
              error={!!errors.city}
              helperText={errors.city}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <CustomAutocomplete
              fullWidth
              options={stateNames}
              getOptionLabel={(opt) => opt}
              value={settings.state || ""}
              onInputChange={(_, newInputValue) => {
                const expanded = expandStateName(newInputValue);
                setSettings((prev) => ({ ...prev, state: expanded }));
              }}
              onChange={(_, newVal) =>
                setSettings((prev) => ({ ...prev, state: newVal || "" }))
              }
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  label="State"
                  placeholder="State"
                  error={!!errors.state}
                  helperText={errors.state}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <CustomTextField
              fullWidth
              label="ZIP Code"
              value={settings.zipCode}
              onChange={handleChange('zipCode')}
              placeholder="Enter Zip Code"
              error={!!errors.zipCode}
              helperText={errors.zipCode}
            />
          </Grid>
           <Grid item xs={12}>
            <Divider sx={{ mt: 2 }} />
          </Grid>
          <Grid item xs={12} >
            <Typography variant="h3" >Company Logo</Typography>
            <Typography color="secondary">
              Upload your company logo
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={6} lg={4}>
            <FormLabel
              sx={{
                fontWeight: 400,
                fontSize: "13px",
                color: "text.primary",
                height: "100%",
              }}
            >
              Logo
            </FormLabel>
            <Box sx={{
              display: "flex", alignItems: "center", px: 2, py: 2, gap: 1,maxWidth: 200,
              border: "1px solid rgba(47, 43, 61, 0.2)", borderRadius: 1, mb: 1,
            }}>
              {logoLoading ? (
                <Typography>Loading...</Typography>
              ) : logoPreview ? (
                <>
                  <img
                    src={logoPreview}
                    alt="Company Logo"
                    style={{ width: 80, height: 80, borderRadius: 6, objectFit: "contain", marginRight: 16 }}
                  />
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/*
                      If there's a new unsaved file (logoFile), only show the Replace button.
                      Once the profile—and with it the attachment API—has been saved,
                      logoFile will be cleared and logoMeta will be set, so we show Delete only.
                    */}
                    {logoFile ? (
                      <Tooltip title="Replace">
                        <IconButton
                          color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                          size="small"
                          component="label"
                          disabled={!hasCompanySavePermission}
                        >
                          <RefreshIcon />
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={handleLogoChange}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Delete">
                        <IconButton
                          color="error"
                          size="small"
                          disabled={!hasCompanySavePermission}
                          onClick={handleLogoDelete}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </>
              ) : (
                <>
                  <Icon icon="tabler:cloud-upload" />
                  <label htmlFor="logo-upload">
                    <Typography
                      sx={{
                        color: hasCompanySavePermission ? "#0052CC" : 'text.secondary',
                        cursor: hasCompanySavePermission ? "pointer" : 'default',
                        "&:hover": { textDecoration: hasCompanySavePermission ? "underline" : "none" },
                        ml: 2,
                      }}
                    >
                      Upload Logo
                    </Typography>
                    <input
                      id="logo-upload"
                      type="file"
                      hidden
                      accept="image/*"
                      {...(hasCompanySavePermission && {
                        onChange: handleLogoChange
                      })}
                    />
                  </label>
                </>
              )}
            </Box>
            <Box sx= {{ maxWidth: 200 }}>
            <Typography color="secondary">
              Recommended: 400x400px or larger, PNG or JPG
            </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Divider sx={{ mt: 2 }} />
          </Grid>
                <Grid item xs={12} >
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", sm: "row" }}
                  justifyContent="space-between"
                  alignItems={{ xs: "flex-start", sm: "center" }} 
                  gap={{ xs: 2, sm: 0 }} 
                >
                  <Box>
                    <Typography variant="h3">Sales Tax Rates</Typography>
                    <Typography color="secondary">
                      Manage tax rates by county
                    </Typography>
                  </Box>
                  </Box>
                </Grid>
          <Grid item xs={12}>
          <FormControl fullWidth>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={5}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <Box>
                    <FormLabel sx={{ marginBottom: 1 }}>
                            Charge Sales Tax on:
                          </FormLabel>
                  <RadioGroup
                    row
                    name="chargeSalesTaxOn"
                    value={settings?.chargeSalesTaxOn?.toLowerCase()}
                    {...(hasCompanySavePermission && {
                      onChange: (e) => setSettings((p) => ({ ...p, chargeSalesTaxOn: e.target.value }))
                    })}
                  >
                    <FormControlLabel
                      value="material"
                      control={<Radio color="success" />}
                      label="Materials"
                    />
                    <FormControlLabel
                      value="services"
                      control={<Radio color="success" />}
                      label="Services"
                    />
                  </RadioGroup>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Button
                  variant="contained"
                  color="main"
                  startIcon={<AddIcon />}
                  disabled={!hasSalesTaxSavePermission}
                  {...(hasSalesTaxSavePermission && {
                    onClick: () => {
                      setEditingTax(null); 
                      handleOpenSalesTaxDlg();
                    }
                  })}
                >
                  Add Sales Tax
                </Button>
              </Grid>
            </Grid>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6.8}>
          <DataGridPro
            key={hasSalesTaxDeletePermission ? "Delete" : "DeleteRevoked"}
            autoHeight
            getRowId={(row) => row.salesTaxID}
            rowSelection={false}
            rows={salesTaxes}
            rowHeight={62}
            slots={{
              footer: () => null
            }}
            columns={columnsSalesTaxRate.map((col) => ({
              ...col,
              renderCell: (params) =>
                col.field === 'actions' ? (
                  <Box>
                    <IconButton
                      size="small"
                      disabled={!hasSalesTaxSavePermission}
                      onClick={() => handleEditTax(params.row)}
                      sx={{ mr: 1 }}
                    >
                    <Icon icon="tabler:pencil" />
                    </IconButton>
                    <IconButton
                      color='error'
                      size="small"
                      disabled={!hasSalesTaxDeletePermission}
                      onClick={() => confirmDeleteTax(params.row.salesTaxID)}
                    >
                      <Icon icon='tabler:trash' />
                    </IconButton>
                  </Box>
                ) : (
                  params.value
                ),
            }))}
            sx={{ '& .MuiDataGrid-columnHeaderTitle': { textTransform: 'none' } }}
            hideFooter
          />
        </Grid>
        <Grid item xs={12}>
          <Box alignItems='flex-end' display='flex' justifyContent='flex-end'>
          <Button 
            variant="contained" 
            color="main" 
            disabled={!hasCompanySavePermission}
            {...(hasCompanySavePermission && {
              onClick: () => handleSaveProfile()
            })}
          >
            Save Profile
          </Button>
          </Box>
        </Grid>
      </Grid>

      <AddSalesTaxDialog
        open={openSalesTaxDlg}
        handleClose={() => {
          setEditingTax(null); 
          handleCloseSalesTaxDlg();
        }}
        onSave={handleAddOrUpdateTax}
        editingTax={editingTax} 
      />
    </>
  );
};

export default CompanySettingsTab;